import script from "./BaseLocalePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseLocalePopup.vue?vue&type=script&setup=true&lang=ts"

import "./BaseLocalePopup.vue?vue&type=style&index=0&id=a4a1d6f4&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4a1d6f4"]])

export default __exports__